<!-- TODO: A supprimer quand l'implémentation v10 sera terminée -->
<custom-frame [frame]="'taxes'" [isTitleHidden]="true"></custom-frame>
